import Lightbox from './Lightbox'
export type { DatatransLightboxConfig } from './Datatrans'

export default Lightbox
